import type {YfmEditorType} from '@yandex-data-ui/yfm-editor';

import {useStateSelector, useAppDispatch} from '~ui/hooks';
import {
    selectUserSettingByKey,
    updateUserSettings as updateUserSettingsThunk,
} from '~ui/store/slices/user-settings';
import {isBoolean} from '~ui/utils';

export const useWysiwygSettings = () => {
    const dispatch = useAppDispatch();
    const editorSettings = useStateSelector(selectUserSettingByKey('editorSettings'));

    const initialEditorType = editorSettings?.editorType;
    const initialMenuVisible = isBoolean(editorSettings?.editorMenuVisibility)
        ? editorSettings?.editorMenuVisibility
        : true;
    const initialSplitModeEnabled = isBoolean(editorSettings?.editorSplitModeEnabled)
        ? editorSettings?.editorSplitModeEnabled
        : false;

    const updateEditorType = (type: YfmEditorType) => {
        return dispatch(
            updateUserSettingsThunk({
                editorSettings: {
                    editorType: type,
                    editorMenuVisibility: initialMenuVisible,
                    editorSplitModeEnabled: initialSplitModeEnabled,
                },
            }),
        );
    };

    const updateSplitModeEnabled = (splitModeEnabled: boolean) => {
        return dispatch(
            updateUserSettingsThunk({
                editorSettings: {
                    editorType: initialEditorType,
                    editorMenuVisibility: initialMenuVisible,
                    editorSplitModeEnabled: splitModeEnabled,
                },
            }),
        );
    };

    const updateMenuVisible = (visibility: boolean) => {
        return dispatch(
            updateUserSettingsThunk({
                editorSettings: {
                    editorMenuVisibility: visibility,
                    editorType: initialEditorType,
                    editorSplitModeEnabled: initialSplitModeEnabled,
                },
            }),
        );
    };

    return {
        initialEditorType,
        updateEditorType,
        initialMenuVisible,
        updateMenuVisible,
        initialSplitModeEnabled,
        updateSplitModeEnabled,
    };
};
